export enum Forms {
  enterForm = 'enterForm',
  loginForm = 'loginForm',
  registrationOrRecoveryForm = 'registrationOrRecoveryForm',
  recoveryByEmailForm = 'recoveryByEmailForm',
  pinCodeAuthenticationForm = 'authenticationForm',
  phoneNumberCheckForm = 'phoneNumberCheckForm',
  changeParameter = 'changeParameterForm',
  changePassword = 'changePasswordForm',
  confirmPhoneForm = 'confirmPhoneForm',
  confirmEmailForm = 'confirmEmailForm',
  desktopSettings = 'desktopSettings',
  visuallyImpaired = 'visuallyImpaired',
  showRequest = 'showRequestForm',
  createRequest = 'createRequest',
  pollForm = 'pollForm',
  applicationsFilterForm = 'applicationsFilterForm',
  newsFilter = 'newsFilter',
  acceptorsFilterForm = 'acceptorsFilterForm',
  citySearchForm = 'citySearchForm',
  esiaRegCardForm = 'esiaRegCardForm',
  kidSubform = 'kidSubform',
  linkAccountForm = 'linkAccountForm',
  esiaActivateCardForm = 'esiaActivateCardForm',
  productsCategoryFilterForm = 'productsCategoryFilterForm',
  productsAcceptorFilterForm = 'productsAcceptorFilterForm',
  productsPriceFilterForm = 'productsPriceFilterForm',
  searchBarForm = 'searchBarForm',
  passwordCreationForm = 'passwordCreationForm',
  documentsForm = 'documentsForm',
}
